module.exports = __webpack_public_path__ + "img/banner3-min-en.17c5daaa.jpg";